export function calculateTotalHours(ordinary, otOne, otTwo) {
  let newordinary = Number(ordinary);
  let newotOne = Number(otOne);
  let newotTwo = Number(otTwo);
  // calculate total hours with 2 decimal places
  let total = (newordinary + newotOne + newotTwo).toFixed(2);
  return total;
}